<template>
	<div>
		<div v-if="is_loading" class="flex flex_align_center flex_justify_center">
			<div class="loading"></div>
		</div>
		<div v-else v-for="stat in stats" class="text_align_left faded_bottom_border">
			<div class="flex flex_align_center flex_justify_between">
				<p style="font-size: 10px;">{{ stat.designator }}</p>
				<p class="uppercase" style="margin-bottom: 10px;"><b>{{ stat.title }}</b></p>
			</div>
			<p v-html="$sanitize(stat.content)" class="white_space_pre_line break_word" />
		</div>
	</div>
</template>
<script>
	export default {
		name: 'resource-stats-form',
		props: ['payload'],
		data(){
			return {
				stats: [],
				is_loading: true
			}
		},
		created(){
			this.$network_utils.getStats({ resource_type: this.payload.resource_type, resource_id: this.payload.resource_id }).then(response => {
				this.stats = response
				this.is_loading = false
			})
		}
	}
</script>